// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TextInput$ReactHooksTemplate = require("../common/TextInput.res.js");

function fieldId(t) {
  return t.fieldId;
}

function name(t) {
  return t.name;
}

function decode(json) {
  return {
          fieldId: Json_decode.field("id", Json_decode.$$int, json),
          name: Json_decode.field("name", Json_decode.string, json)
        };
}

var KpiFields = {
  fieldId: fieldId,
  name: name,
  emptyFields: /* [] */0,
  decode: decode
};

function userId(t) {
  return t.userId;
}

function email(t) {
  return t.email;
}

function decode$1(json) {
  return {
          userId: Json_decode.field("id", Json_decode.$$int, json),
          email: Json_decode.field("email", Json_decode.string, json)
        };
}

var KpiUser = {
  userId: userId,
  email: email,
  emptyUsers: /* [] */0,
  decode: decode$1
};

var emptyFormInfo = {
  email: "",
  field: "",
  value: "",
  kpi: 0
};

function UserKpiCreate(props) {
  var match = React.useState(function (param) {
        return emptyFormInfo;
      });
  var setFormInfo = match[1];
  var formInfo = match[0];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setUsers = match$1[1];
  var match$2 = React.useState(function (param) {
        return /* [] */0;
      });
  var setFields = match$2[1];
  var match$3 = React.useState(function (param) {
        return /* [] */0;
      });
  var setValues = match$3[1];
  var match$4 = React.useState(function (param) {
        return "";
      });
  var setformSubmitMessage = match$4[1];
  var formSubmitMessage = match$4[0];
  React.useEffect((function (param) {
          Js_promise.then_((function (users) {
                  return Promise.resolve(Curry._1(setUsers, (function (param) {
                                    return users;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/users", (function (param) {
                      return Json_decode.field("users", (function (param) {
                                    return Json_decode.list(decode$1, param);
                                  }), param);
                    })));
          Js_promise.then_((function (fields) {
                  return Promise.resolve(Curry._1(setFields, (function (param) {
                                    return fields;
                                  })));
                }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/kpi_fields", (function (param) {
                      return Json_decode.field("fields", (function (param) {
                                    return Json_decode.list(decode, param);
                                  }), param);
                    })));
        }), []);
  var buildSurveyFormDict = function (form) {
    var params = {};
    params["user_id"] = form.email;
    params["field"] = form.field;
    params["value"] = form.value;
    params["kpi"] = form.kpi;
    console.log("-----PARAMS-----");
    console.log(params);
    console.log("-----PARAMS-----");
    return params;
  };
  var handleEmailChange = function ($$event) {
    var email = Utils$ReactHooksTemplate.formTargetValue($$event);
    console.log(email);
    Curry._1(setFormInfo, (function (formInfo) {
            return {
                    email: email,
                    field: formInfo.field,
                    value: formInfo.value,
                    kpi: formInfo.kpi
                  };
          }));
  };
  var handleFieldChange = function ($$event) {
    var field = Utils$ReactHooksTemplate.formTargetValue($$event);
    Js_promise.then_((function (values) {
            return Promise.resolve(Curry._1(setValues, (function (param) {
                              return values;
                            })));
          }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/kpis/field_values?field_id=" + field, (function (param) {
                return Json_decode.field("field_values", (function (param) {
                              return Json_decode.list(Json_decode.string, param);
                            }), param);
              })));
    Curry._1(setFormInfo, (function (formInfo) {
            return {
                    email: formInfo.email,
                    field: field,
                    value: formInfo.value,
                    kpi: formInfo.kpi
                  };
          }));
  };
  var handleValueChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setFormInfo, (function (formInfo) {
            return {
                    email: formInfo.email,
                    field: formInfo.field,
                    value: value,
                    kpi: formInfo.kpi
                  };
          }));
  };
  var handleKpiChange = function ($$event) {
    var kpi = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setFormInfo, (function (formInfo) {
            return {
                    email: formInfo.email,
                    field: formInfo.field,
                    value: formInfo.value,
                    kpi: kpi
                  };
          }));
  };
  var handleClose = function (param) {
    Curry._1(setformSubmitMessage, (function (param) {
            return "";
          }));
  };
  var tmp = formSubmitMessage === "" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("strong", {
                            children: "Error!",
                            className: "font-bold"
                          }),
                      JsxRuntime.jsx("span", {
                            children: formSubmitMessage,
                            className: "block sm:inline"
                          }),
                      JsxRuntime.jsx("span", {
                            children: JsxRuntime.jsxs("svg", {
                                  children: [
                                    JsxRuntime.jsx("title", {
                                          children: "Close"
                                        }),
                                    JsxRuntime.jsx("path", {
                                          d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"
                                        })
                                  ],
                                  className: "fill-current h-6 w-6 text-red-500",
                                  role: "button",
                                  onClick: handleClose,
                                  viewBox: "0 0 20 20",
                                  xmlns: "http://www.w3.org/2000/svg"
                                }),
                            className: "absolute top-0 bottom-0 right-0 px-4 py-3"
                          })
                    ],
                    className: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",
                    role: "alert"
                  }))
        });
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("h1", {
                                children: "New KPI",
                                className: "text-32-px mb-30-px"
                              }),
                          tmp,
                          JsxRuntime.jsxs("form", {
                                children: [
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("select", {
                                              children: [
                                                JsxRuntime.jsx("option", {
                                                      children: "Select Email",
                                                      disabled: true,
                                                      value: "Select Email"
                                                    }, "0"),
                                                $$Array.of_list(Belt_List.map(match$1[0], (function (user) {
                                                            return JsxRuntime.jsx("option", {
                                                                        children: user.email,
                                                                        value: String(user.userId)
                                                                      }, String(user.userId));
                                                          })))
                                              ],
                                              className: "block py-2.5 px-0 w-400-px text-sm text-gray-700 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer",
                                              placeholder: "Select Email",
                                              value: formInfo.email === "" ? "Select Email" : formInfo.email,
                                              onChange: handleEmailChange
                                            }),
                                        className: "flex mt-30-px mb-30-px items-center"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("select", {
                                              children: [
                                                JsxRuntime.jsx("option", {
                                                      children: "Select Field",
                                                      disabled: true,
                                                      value: "Select Field"
                                                    }, "0"),
                                                $$Array.of_list(Belt_List.map(match$2[0], (function (field) {
                                                            return JsxRuntime.jsx("option", {
                                                                        children: field.name,
                                                                        value: String(field.fieldId)
                                                                      }, String(field.fieldId));
                                                          })))
                                              ],
                                              className: "block py-2.5 px-0 w-400-px text-sm text-gray-700 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer",
                                              placeholder: "Select Field",
                                              value: formInfo.field === "" ? "Select Field" : formInfo.field,
                                              onChange: handleFieldChange
                                            }),
                                        className: "flex mb-30-px items-center"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsxs("select", {
                                              children: [
                                                JsxRuntime.jsx("option", {
                                                      children: "Select Value",
                                                      disabled: true,
                                                      value: "Select Value"
                                                    }, "00"),
                                                $$Array.of_list(Belt_List.mapWithIndex(match$3[0], (function (id, value) {
                                                            return JsxRuntime.jsx("option", {
                                                                        children: value,
                                                                        value: value
                                                                      }, String(id + 1 | 0));
                                                          })))
                                              ],
                                              className: "block py-2.5 px-0 w-400-px text-sm text-gray-700 bg-transparent border-0 border-b-2 border-gray-200 appearance-none dark:text-gray-400 dark:border-gray-700 focus:outline-none focus:ring-0 focus:border-gray-200 peer",
                                              placeholder: "Select Value",
                                              value: formInfo.value === "" ? "Select Value" : formInfo.value,
                                              onChange: handleValueChange
                                            }),
                                        className: "flex mb-30-px items-center"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(TextInput$ReactHooksTemplate.make, {
                                                    label: "KPI",
                                                    value: String(formInfo.kpi),
                                                    handleChange: handleKpiChange
                                                  }),
                                              className: "w-1/2"
                                            }),
                                        className: "flex mb-30-px items-center"
                                      }),
                                  JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("input", {
                                              className: "bg-teal-500 hover:bg-teal-700 py-6-px px-20-px font-normal text-white font-16-px",
                                              type: "submit",
                                              value: "Submit"
                                            })
                                      })
                                ],
                                onSubmit: (function (param) {
                                    param.preventDefault();
                                    Js_promise.then_((function (response) {
                                            var status = Json_decode.field("status", Json_decode.string, response);
                                            var description = Json_decode.field("description", Json_decode.string, response);
                                            switch (status) {
                                              case "error" :
                                                  Curry._1(setformSubmitMessage, (function (param) {
                                                          return description;
                                                        }));
                                                  break;
                                              case "success" :
                                                  RescriptReactRouter.push("/users/kpi");
                                                  break;
                                              default:
                                                Curry._1(setformSubmitMessage, (function (param) {
                                                        return "Success.........";
                                                      }));
                                            }
                                            return Promise.resolve((console.log(response), undefined));
                                          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/kpis", buildSurveyFormDict(formInfo)));
                                  })
                              })
                        ],
                        className: "p-30-px m-30-px w-2/3 bg-white"
                      }))
            });
}

var make = UserKpiCreate;

exports.KpiFields = KpiFields;
exports.KpiUser = KpiUser;
exports.emptyFormInfo = emptyFormInfo;
exports.make = make;
/* react Not a pure module */
